export const lodgingRequestsUrl = '/lodgingRequests';
export const lodgingAdminUrl = '/lodgingAdmin';
export const employeesRoute = 'employees';
export const employeesItemOptionsRoute = `${employeesRoute}/items/options`;
export const employeeDepartmentRoute = 'departments';
export const permitRoute = 'permits';
export const softPhoneNewJobRoute = '/softphone/new-job';
